<!-- 🔴 SIN FONDO DE PÁGINA — 2026-09-21. La consola pasó a blanco; un
     envoltorio que pinta su propio gris vuelve a meter el escalón. -->
<div class="container-fluid py-4 min-vh-100">
  <!-- ========================================
       HEADER ELEGANTE
       ======================================== -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card border-0 shadow-sm">
        <div class="card-body py-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h2 class="mb-2 text-primary fw-bold">
                <i class="fas fa-history me-2"></i>
                Historial Global de Cambios de Cupo
              </h2>
              <p class="text-muted mb-0">
                <i class="fas fa-info-circle me-1"></i>
                Consulta de cambios de cupo realizados por ejecutivos del sistema
              </p>
            </div>
            
            <div>
              <button 
                type="button" 
                class="btn btn-outline-primary btn-lg"
                routerLink="/console/credito">
                <i class="fas fa-arrow-left me-2"></i>
                Volver al Panel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       FILTROS MODERNOS
       ======================================== -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card border-0 shadow-sm">
        <div class="card-header bg-primary text-white py-3">
          <h5 class="mb-0 fw-bold">
            <i class="fas fa-sliders-h me-2"></i>
            Filtros de Búsqueda
          </h5>
        </div>
        <div class="card-body p-4">
          <!-- ========================================
               SELECTOR DE EJECUTIVO CON BÚSQUEDA
               ======================================== -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-bold text-dark mb-3">
                <i class="fas fa-user-tie text-primary me-2"></i>
                Seleccionar Ejecutivo
                <span class="badge bg-danger ms-2">Obligatorio</span>
              </label>
              
              <!-- Loading State -->
              <div *ngIf="loadingExecutives" class="text-center py-4 bg-light rounded">
                <div class="spinner-border text-primary mb-2" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="text-muted mb-0">Cargando lista de ejecutivos...</p>
              </div>
              
              <!-- Selector Custom con Búsqueda -->
              <div *ngIf="!loadingExecutives" class="position-relative">
                <!-- Input de Selección -->
                <div class="input-group input-group-lg shadow-sm">
                  <span class="input-group-text bg-white border-end-0">
                    <i class="fas fa-search text-muted"></i>
                  </span>
                  <input 
                    type="text" 
                    class="form-control border-start-0 ps-0"
                    [value]="selectedExecutiveName || 'Haga clic para seleccionar un ejecutivo...'"
                    (click)="toggleExecutiveDropdown()"
                    readonly
                    style="cursor: pointer; background-color: white;">
                  <button 
                    *ngIf="selectedExecutive" 
                    class="btn btn-outline-danger"
                    type="button"
                    (click)="clearExecutiveSelection()">
                    <i class="fas fa-times"></i>
                  </button>
                  <button 
                    class="btn btn-primary"
                    type="button"
                    (click)="toggleExecutiveDropdown()">
                    <i class="fas" [class.fa-chevron-down]="!showExecutiveDropdown" [class.fa-chevron-up]="showExecutiveDropdown"></i>
                  </button>
                </div>

                <!-- Dropdown Menu -->
                <div *ngIf="showExecutiveDropdown" 
                     class="card position-absolute w-100 mt-2 shadow-lg border-primary"
                     style="z-index: 9999; max-height: 400px; overflow-y: auto;">
                  <div class="card-body p-0">
                    <!-- Búsqueda Interna -->
                    <div class="p-3 border-bottom bg-light sticky-top">
                      <input 
                        type="text" 
                        class="form-control"
                        placeholder="🔍 Filtrar ejecutivos..."
                        [(ngModel)]="executiveSearchTerm"
                        (ngModelChange)="filterExecutives()"
                        autofocus>
                      <small class="text-muted mt-1 d-block">
                        {{ executives.length }} de {{ allExecutives.length }} ejecutivo(s)
                      </small>
                    </div>
                    
                    <!-- Lista de Ejecutivos -->
                    <div class="list-group list-group-flush">
                      <button 
                        *ngFor="let exec of executives" 
                        type="button"
                        class="list-group-item list-group-item-action d-flex align-items-center executive-item"
                        [class.active-executive]="selectedExecutive === exec.code"
                        (click)="selectExecutive(exec)">
                        <i class="fas fa-user-circle me-3 fs-5" 
                           [class.text-white]="selectedExecutive === exec.code"
                           [class.text-primary]="selectedExecutive !== exec.code"></i>
                        <span class="fw-medium">{{ exec.nombreCompleto }}</span>
                        <i *ngIf="selectedExecutive === exec.code" class="fas fa-check ms-auto text-white"></i>
                      </button>
                      
                      <div *ngIf="executives.length === 0" class="p-4 text-center text-muted">
                        <i class="fas fa-search mb-2 fs-4"></i>
                        <p class="mb-0">No se encontraron ejecutivos</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Ejecutivo Seleccionado -->
              <div *ngIf="selectedExecutive" class="alert alert-success mt-3 mb-0 d-flex align-items-center">
                <i class="fas fa-check-circle me-2 fs-5"></i>
                <div>
                  <strong>Ejecutivo seleccionado:</strong> {{ selectedExecutiveName }}
                </div>
              </div>
            </div>
          </div>

          <hr class="my-4">

          <!-- ========================================
               FILTROS DE FECHA CON MOBISCROLL
               ======================================== -->
          <div class="row" [class.opacity-50]="!canSearch">
            <div class="col-12 mb-3">
              <h6 class="text-dark fw-bold">
                <i class="fas fa-calendar-alt text-primary me-2"></i>
                Filtros de Fecha (Opcional)
              </h6>
              <p class="text-muted small mb-3">
                Seleccione un rango de fechas para filtrar los resultados
              </p>
            </div>
            
            <!-- Fecha Inicio -->
            <div class="col-md-4">
              <label class="form-label fw-medium">Fecha Inicio</label>
              <div class="d-block d-md-none">
                <mbsc-date 
                  [(ngModel)]="dateRangeStart"
                  [options]="mobileDateSettings"
                  [disabled]="!canSearch || loadingHistory"
                  placeholder="Seleccione fecha inicio">
                </mbsc-date>
              </div>
              <div class="d-none d-md-block">
                <mbsc-date 
                  [(ngModel)]="dateRangeStart"
                  [options]="desktopDateSettings"
                  [disabled]="!canSearch || loadingHistory"
                  placeholder="Seleccione fecha inicio">
                </mbsc-date>
              </div>
            </div>
            
            <!-- Fecha Fin -->
            <div class="col-md-4">
              <label class="form-label fw-medium">Fecha Fin</label>
              <div class="d-block d-md-none">
                <mbsc-date 
                  [(ngModel)]="dateRangeEnd"
                  [options]="mobileDateSettings"
                  [disabled]="!canSearch || loadingHistory"
                  placeholder="Seleccione fecha fin">
                </mbsc-date>
              </div>
              <div class="d-none d-md-block">
                <mbsc-date 
                  [(ngModel)]="dateRangeEnd"
                  [options]="desktopDateSettings"
                  [disabled]="!canSearch || loadingHistory"
                  placeholder="Seleccione fecha fin">
                </mbsc-date>
              </div>
            </div>
            
            <!-- Botones de Acción -->
            <div class="col-md-4 d-flex align-items-end gap-2">
              <button 
                *ngIf="dateRangeStart || dateRangeEnd"
                type="button" 
                class="btn btn-outline-secondary flex-fill"
                (click)="clearFilters()"
                [disabled]="loadingHistory"
                title="Limpiar filtros de fecha">
                <i class="fas fa-times me-2"></i>
                Limpiar Filtros
              </button>
              
              <div *ngIf="!dateRangeStart && !dateRangeEnd" class="text-muted small">
                <i class="fas fa-info-circle me-1"></i>
                La búsqueda se realiza automáticamente
              </div>
            </div>
          </div>

          <!-- Info de Filtros Activos -->
          <div *ngIf="dateRangeStart && dateRangeEnd" class="row mt-3">
            <div class="col-12">
              <div class="alert alert-info mb-0 d-flex align-items-center">
                <i class="fas fa-filter me-2"></i>
                <small>
                  <strong>Rango seleccionado:</strong> 
                  {{ dateRangeStart | date:'dd/MM/yyyy' }} - {{ dateRangeEnd | date:'dd/MM/yyyy' }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       ESTADO INICIAL - SIN EJECUTIVO
       ======================================== -->
  <div *ngIf="!canSearch && !loadingHistory" class="row">
    <div class="col-12">
      <div class="card border-0 shadow-sm">
        <div class="card-body text-center py-5">
          <div class="mb-4">
            <i class="fas fa-user-tie" style="font-size: 5rem; color: #e0e0e0;"></i>
          </div>
          <h4 class="text-muted fw-bold mb-2">Seleccione un ejecutivo para comenzar</h4>
          <p class="text-muted mb-0">
            Utilice el selector de arriba para elegir el ejecutivo y consultar su historial de cambios de cupo
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       LOADING STATE ELEGANTE
       ======================================== -->
  <div *ngIf="loadingHistory" class="row">
    <div class="col-12">
      <div class="card border-0 shadow-sm">
        <div class="card-body text-center py-5">
          <div class="spinner-border text-primary mb-3" style="width: 4rem; height: 4rem;" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <h5 class="text-primary fw-bold mb-2">Consultando historial de cambios...</h5>
          <p class="text-muted mb-0">
            <i class="fas fa-clock me-1"></i>
            Por favor espere mientras procesamos su solicitud
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       EMPTY STATE - SIN RESULTADOS
       ======================================== -->
  <div *ngIf="canSearch && !loadingHistory && quotaHistory.length === 0 && selectedExecutive" class="row">
    <div class="col-12">
      <div class="card border-0 shadow-sm">
        <div class="card-body text-center py-5">
          <div class="mb-4">
            <i class="fas fa-inbox" style="font-size: 5rem; color: #e0e0e0;"></i>
          </div>
          <h4 class="text-muted fw-bold mb-2">No se encontraron cambios de cupo</h4>
          <p class="text-muted mb-3">
            No hay registros para el ejecutivo seleccionado con los filtros aplicados
          </p>
          <button class="btn btn-outline-primary" (click)="clearFilters()">
            <i class="fas fa-redo me-2"></i>
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       RESULTADOS - TABLA PROFESIONAL
       ======================================== -->
  <div *ngIf="!loadingHistory && quotaHistory.length > 0" class="row">
    <div class="col-12">
      <div class="card border-0 shadow-sm">
        <!-- Header de Resultados -->
        <div class="card-header bg-primary text-white py-3 d-flex justify-content-between align-items-center">
          <h5 class="mb-0 fw-bold">
            <i class="fas fa-table me-2"></i>
            Resultados del Historial
          </h5>
          <span class="badge bg-white text-dark fs-6 px-3 py-2">
            <i class="fas fa-list-ol me-2"></i>
            {{ historyTotal }} registro(s)
          </span>
        </div>

        <!-- Tabla Responsive Mejorada -->
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th class="py-3">
                    <i class="fas fa-calendar-alt me-2"></i>
                    Fecha
                  </th>
                  <th class="py-3" style="min-width: 250px;">
                    <i class="fas fa-user me-2"></i>
                    Ejecutivo
                  </th>
                  <th class="py-3">
                    <i class="fas fa-user-circle me-2"></i>
                    Cliente
                  </th>
                  <th class="py-3 text-center">
                    <i class="fas fa-wallet me-2"></i>
                    Cupo Asignado
                  </th>
                  <th class="py-3 text-center">
                    <i class="fas fa-money-bill-wave me-2"></i>
                    Cupo Disponible
                  </th>
                  <th class="py-3 text-center">
                    <i class="fas fa-dollar-sign me-2"></i>
                    Ajuste
                  </th>
                  <th class="py-3 text-center">
                    <i class="fas fa-stream me-2"></i>
                    Canal
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of quotaHistory" class="border-bottom">
                  <!-- Fecha y Hora -->
                  <td class="py-3">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center mb-1">
                        <i class="fas fa-calendar-alt text-primary me-2"></i>
                        <strong>{{ item.fechaCambio }}</strong>
                      </div>
                      <div class="d-flex align-items-center text-muted small" *ngIf="item.horaCambio">
                        <i class="fas fa-clock text-muted me-2" style="font-size: 0.75rem;"></i>
                        <span>{{ item.horaCambio }}</span>
                      </div>
                    </div>
                  </td>
                  
                  <!-- Ejecutivo -->
                  <td class="py-3" style="white-space: nowrap;">
                    <div class="d-flex align-items-center">
                      <div class="bg-primary bg-opacity-10 rounded-circle p-2 me-2">
                        <i class="fas fa-user text-primary"></i>
                      </div>
                      <span class="fw-medium">
                        {{ item.ejecutivo || 'Sin ejecutivo' }}
                      </span>
                    </div>
                  </td>
                  
                  <!-- Cliente con botón de copiar -->
                  <td class="py-3">
                    <div class="d-flex align-items-center gap-2">
                      <i class="fas fa-user-circle text-primary me-1"></i>
                      <span class="fw-medium">{{ item.nombrePersonaAfectada }}</span>
                      <button 
                        class="btn btn-sm btn-outline-primary ms-2"
                        (click)="copyClientCode(item.codigoPersonaAfectada)"
                        title="Copiar código del cliente"
                        type="button">
                        <i class="fas fa-copy"></i>
                      </button>
                    </div>
                  </td>
                  
                  <!-- Cupo Asignado con Transición Visual -->
                  <td class="py-3 text-center">
                    <div class="d-flex align-items-center justify-content-center gap-2">
                      <span class="text-muted small text-decoration-line-through">${{ item.currentQuotaAntigua | number:'1.2-2' }}</span>
                      <i [ngClass]="getQuotaChangeIcon(item.currentQuotaAntigua, item.currentQuotaNueva)"
                         [class]="getQuotaChangeClass(item.currentQuotaAntigua, item.currentQuotaNueva)"
                         class="fs-5"></i>
                      <span class="fw-bold fs-6" [class]="getQuotaChangeClass(item.currentQuotaAntigua, item.currentQuotaNueva)">
                        ${{ item.currentQuotaNueva | number:'1.2-2' }}
                      </span>
                    </div>
                  </td>
                  
                  <!-- Cupo Disponible con Transición Visual -->
                  <td class="py-3 text-center">
                    <div class="d-flex align-items-center justify-content-center gap-2">
                      <span class="text-muted small text-decoration-line-through">${{ item.quotaAntigua | number:'1.2-2' }}</span>
                      <i [ngClass]="getQuotaChangeIcon(item.quotaAntigua, item.quotaNueva)"
                         [class]="getQuotaChangeClass(item.quotaAntigua, item.quotaNueva)"
                         class="fs-5"></i>
                      <span class="fw-bold fs-6" [class]="getQuotaChangeClass(item.quotaAntigua, item.quotaNueva)">
                        ${{ item.quotaNueva | number:'1.2-2' }}
                      </span>
                    </div>
                  </td>
                  
                  <!-- Monto de Ajuste -->
                  <td class="py-3 text-center">
                    <span class="badge px-3 py-2 fs-6"
                          [class.bg-secondary]="item.montoAjuste === 0"
                          [class.bg-success]="item.montoAjuste !== 0 && item.tipoIncremento === 'S'"
                          [class.bg-danger]="item.montoAjuste !== 0 && item.tipoIncremento !== 'S'">
                      <ng-container *ngIf="item.montoAjuste !== 0">
                        <i class="fas me-1" [class.fa-plus]="item.tipoIncremento === 'S'" [class.fa-minus]="item.tipoIncremento !== 'S'"></i>
                      </ng-container>
                      ${{ item.montoAjuste | number:'1.2-2' }}
                    </span>
                  </td>
                  <!-- Canal -->
                  <td class="py-3 text-center">
                    <span class="badge bg-secondary px-3 py-2 fs-6">{{ item.canal || '—' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer con Paginación Elegante -->
          <div *ngIf="historyTotalPages > 1" class="card-footer bg-light py-3">
            <div class="d-flex justify-content-between align-items-center">
              <button 
                class="btn btn-outline-primary"
                (click)="changeHistoryPage(historyPage - 1)" 
                [disabled]="historyPage === 1">
                <i class="fas fa-chevron-left me-2"></i>
                Anterior
              </button>
              
              <div class="text-center">
                <div class="fw-bold text-dark">
                  Página {{ historyPage }} de {{ historyTotalPages }}
                </div>
                <small class="text-muted">
                  Mostrando {{ quotaHistory.length }} de {{ historyTotal }} registros
                </small>
              </div>
              
              <button 
                class="btn btn-outline-primary"
                (click)="changeHistoryPage(historyPage + 1)" 
                [disabled]="historyPage === historyTotalPages">
                Siguiente
                <i class="fas fa-chevron-right ms-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
